export default "__VITE_ASSET__DkVvRPV9__"